module.exports = __webpack_public_path__ + "img/guzhiReport4.87d5f677.png";